import React from 'react'

import { SegmentButton, SegmentedGroup } from './styles'

interface SegmentOption<T extends string> {
  value: T
  label: string
}

interface SegmentedControlProps<T extends string> {
  label: string
  options: SegmentOption<T>[]
  value: T
  onChange: (value: T) => void
}

const SegmentedControl = <T extends string>({
  label,
  onChange,
  options,
  value,
}: SegmentedControlProps<T>) => (
  <SegmentedGroup role="radiogroup" aria-label={label}>
    {options.map((option) => (
      <SegmentButton
        key={option.value}
        type="button"
        role="radio"
        aria-checked={option.value === value}
        $active={option.value === value}
        onClick={() => onChange(option.value)}
      >
        {option.label}
      </SegmentButton>
    ))}
  </SegmentedGroup>
)

export default SegmentedControl
